import React from 'react';
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 border-b border-primary/20 py-2 px-4 text-center shadow-sm bg-[#F4F3F3]" data-id="element-228">
      <p className="text-dark text-sm md:text-base font-bold" data-id="element-229">
        <span className="text-primary" data-id="element-230">⚠️ ATENCIÓN:</span> Oferta de lanzamiento
        de $6.36 termina hoy (Quedan 14 cupos).
      </p>
    </div>;
}